import React from 'react';
import ConfigurationsSettingsPage from '../../../pages/parentSettings/ConfigurationsSettingsPage';

const ConfigurationsContainer: React.FC = () => {
  return <ConfigurationsSettingsPage />;
};

export default ConfigurationsContainer;
